import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIleggelseKlager } from "../../../../actions/ileggelserActions";
import Klageinformasjon from "../../Detalj/Klageinformasjon";

export default function KlageinformasjonContainer({ ileggelseId }) {
  const ileggelseKlager = useSelector((state) => state.ileggelseKlager);
  const dispatch = useDispatch();

  useEffect(() => {
    if (ileggelseId) dispatch(getIleggelseKlager(ileggelseId));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Klageinformasjon klager={ileggelseKlager} />;
}

KlageinformasjonContainer.propTypes = {
  ileggelseId: PropTypes.string,
};
